import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { Router } from '@angular/router';
import { AppEnum } from 'src/app/appenum';
import { EncryptionService } from './encryption.service';
import { catchError, delayWhen, filter, retryWhen, take } from 'rxjs/operators';
import { AppService } from './app.service';
import { ToastController } from '@ionic/angular';

import { LoggingService } from './logging.service';
import { wrapAllMethodsWithLogging } from 'src/app/core/decorators/log-all-errors.decorator';

@Injectable()
export class sessionInterceptor implements HttpInterceptor {
  public count = 0;
  componentName: string = 'sessionInterceptorService';
  constructor(private _appenum: AppEnum, public encryptionService: EncryptionService,
    public _toastController: ToastController,
    private injector: Injector
  ) {
    wrapAllMethodsWithLogging(this, this.componentName, this.injector, LoggingService);
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this.encryptionService.decrypt(
      this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.authtoken)
    );

    const headersObj: any = {
      'X-Frame-Options': 'deny',
      'X-Content-Type-Options': 'nosniff',
      'X-XSS-Protection': '1; mode=block',
      'Content-Security-Policy': "frame-ancestors 'self'",
      'Cache-Control': 'no-cache',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'ReqBodyenc': 'true'
    };

    if (authToken) {
      headersObj['Authorization'] = `Bearer ${authToken}`;
    }

    const headers = new HttpHeaders(headersObj);
    const authReq = req.clone({ headers });

    return next.handle(authReq).pipe(
      retryWhen(errors =>
        errors.pipe(
          // Retry only for certain types of errors (optional)
          filter((error: HttpErrorResponse) => {
            // this.showToast('Something went wrong please try later');
            // Retry only for network or 5xx server errors
            return error.status === 0 || (error.status >= 500 && error.status < 600);
          }),
          delayWhen(() => timer(5000)), // 3-second delay
          take(2) // Retry up to 2 times
        )
      ),
      catchError((error: HttpErrorResponse) => {
        const logRequest = {
          url: error?.url || req.url,
          payload: authReq.body,
          message: error?.message,
          status: error?.status
        };

        console.log('Interceptor caught error after retries:', logRequest);

        // Optional logging service:
        // this._appServices.logsActivity(...);

        return throwError(() => error);
      })
    );
  }

  async showToast(message) {
    const toast = await this._toastController.create({
      message: message,
      position: "top",
      duration: 10000,
      cssClass: 'custom-toast-error'
    });
    toast.present();
  }
}
